import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-ccs-help-action',
  imports: [MatButtonModule, MatDialogModule],
  template: `
    <button mat-flat-button mat-dialog-close class="lg w-full md:flex-1 !py-6">
      Close
    </button>
  `,
  styleUrls: ['./ccs-help-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CcsHelpActionComponent {}
